import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    ibanPayment: 'Bank transfer',
    ibanPaymentDescription:
      'Free for payments in Europe (SEPA zone) up to your offer ({0} excl. VAT beyond)',
    swiftPaymentDescription:
      'Paid for SWIFT transfers ({0} excl. VAT charged upon receipt)',
  },
  fr: {
    ibanPayment: 'Virement bancaire',
    ibanPaymentDescription:
      'Gratuit pour les virements en Europe (zone SEPA) dans la limite de votre offre ({0} HT au delà)',
    swiftPaymentDescription:
      'Payant pour les virements SWIFT ({0} HT facturé à la réception)',
  },
} as const);

export default locales;
